import {
  POST_DEVICETYPES_CATALOG,
  POST_DEVICETYPES_CATALOG_SUCCESS,
  POST_DEVICETYPES_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const postDeviceTypesCatalogRed = (state: any = false, actions: any) => {
  switch (actions.type) {
    case POST_DEVICETYPES_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case POST_DEVICETYPES_CATALOG_ERROR:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case POST_DEVICETYPES_CATALOG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
